<template>
  <div class="tw:relative tw:md:px-0 tw:px-0 tw:w-full tw:bg-white tw:border-solid tw:border-b tw:border-gray-300">
    <ContainerLayout class="tw:flex-col tw:w-full">
      <StatusBar />
      <UpdateConnectivityProvider />
      <div ref="rcNav" class="tw:w-full">
        <AppMenu product="rate-connect" :data="menuItems" :loading="isFetching" />
      </div>
    </ContainerLayout>
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue'

import AppMenu from '@/components/appMenu/AppMenu.vue'
import StatusBar from '@/components/rateConnect/StatusBar.vue'
import ContainerLayout from '@/layouts/ContainerLayout.vue'
import UpdateConnectivityProvider from '@/components/rateConnect/settings/UpdateConnectivityProvider.vue'

import { useCampaign } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'
import { useScrollTo } from '@/composables/useScrollTo'

const { isFetching, currentCampaignType } = useCampaign(selectedAccommodationId)

const { register } = useScrollTo()

const rcNav = ref(null)

onMounted(async () => {
  await nextTick()

  register('rcNav', rcNav.value)
})

onBeforeUnmount(() => {
  register('rcNav', null)
})

const shouldShowSmartBoost = import.meta.env.VITE_FEATURE_VISIBLE === 'true'
const menuItems = computed(() => {
  const allMenuItems = [
    {
      label: 'rc_tabs_performance',
      route: '/rate-connect/running/performance',
      testId: 'rc-tabs-performance',
      withBadge: false,
      id: 'performance',
    },
    {
      label: 'rc_booking_details',
      route: '/rate-connect/running/booking-details',
      testId: 'rc-tabs-booking-details',
      withBadge: false,
      id: 'booking',
    },
    {
      label: 'rc_smartboost_tab',
      route: '/rate-connect/running/smart-boost',
      testId: 'rc-tabs-smart-boost',
      withBadge: true,
      id: 'smart_boost',
    },
    {
      label: 'rc_opportunities_tab',
      route: '/rate-connect/running/opportunity',
      testId: 'rc-tabs-opportunity',
      withBadge: false,
      id: 'opportunities',
    },
    {
      label: 'rc_tabs_bidding',
      route: '/rate-connect/running/bidding',
      testId: 'rc-tabs-bidding',
      withBadge: false,
      id: 'bidding',
    },
    {
      label: 'rc_tabs_markets',
      route: '/rate-connect/running/markets',
      testId: 'rc-tabs-markets',
      withBadge: false,
      id: 'markets',
    },
    {
      label: 'tcm_campaign',
      route: '/rate-connect/running/budget',
      testId: 'rc-tabs-budget',
      withBadge: false,
      id: 'budget',
    },
  ]

  return allMenuItems.filter(item => {
    if (!shouldShowSmartBoost && item.id === 'smart_boost') {
      return false
    }

    if (currentCampaignType.value === 'cpc') {
      return item.id !== 'smart_boost' && item.id !== 'opportunities'
    } else {
      return item.id !== 'bidding' && item.id !== 'budget'
    }
  })
})
</script>
